import { SectionF4 } from '@/components/UI/svg/CES';
import { useGlobal } from '@/utils/useGlobal';
import ScrollWordsLayering from '@/components/ScrollWordsLayering';
import ScrollOpacity from '@/components/ScrollOpacity';
import EFVideoModal from '@/components/UI/EFVideoModal';
import EFVideo from '@/components/UI/EFVideo';
import { createEFPic } from '@/utils/useEFPic';

const { EFPic } = createEFPic('/media/ces/pc/');

export default function SectionE() {
    const { useLang, useRouter, useState } = useGlobal();
    const { t } = useLang('ces2023');
    const { locale } = useRouter();
    const [videoModal, setVideoModal] = useState(false);
    const playerType = locale === 'cn' ? 'Alibaba' : 'YouTube';
    return (
        <>
            <div className="sectionD sectionStyle">
                <div className="textContainer">
                    <div className="title1">
                        <ScrollOpacity scrollRatio={3} leaveAdvanceRatio={0.5}>
                            <ScrollWordsLayering lines={2} scrollRatio={3}>
                                {t('sectionD.title')}
                            </ScrollWordsLayering>
                        </ScrollOpacity>
                    </div>
                    <div className="desc1">
                        <ScrollOpacity scrollRatio={3} leaveAdvanceRatio={0.5}>
                            <ScrollWordsLayering lines={2} scrollRatio={3}>
                                {t('sectionD.desc1')}
                            </ScrollWordsLayering>
                        </ScrollOpacity>
                    </div>
                </div>
                <div className="imgContainer">
                    <EFVideo sources={['/media/ces/whole-home.webm', '/media/ces/whole-home.mp4']} autoPlay muted width="100%" height="100%" />
                </div>
                <ScrollOpacity scrollRatio={3} enterDelayRatio={0.5} leaveAdvanceRatio={0.5}>
                    <div className="secondContent">{t('sectionD.desc2')}</div>
                    <div className="videoBtn" onClick={() => setVideoModal(true)}>
                        <span>{t('sectionD.videoBtn')}</span>
                        <div className="play"></div>
                    </div>
                </ScrollOpacity>
            </div>
            <div className="sectionF sectionStyle">
                <ScrollOpacity scrollRatio={3} enterDelayRatio={0} leaveAdvanceRatio={0}>
                    <div className="sectionFWrapper">
                        <div className="item item-1">
                            <EFPic name={['05-1.webp', '05-1.png']} />
                            <div className="desc">{t('sectionF.desc1')}</div>
                        </div>
                        <div className="item item-2">
                            <EFPic name={['05-2.webp', '05-2.png']} />
                            <div className="text-wrapper">
                                <div className="desc1">{t('sectionF.desc2')}</div>
                                <div className="desc2">{t('sectionF.desc3')}</div>
                            </div>
                        </div>
                        <div className="item item-3">
                            <EFPic name={['05-3.webp', '05-3.png']} />
                            <div className="desc">{t('sectionF.desc5')}</div>
                        </div>
                        <div className="item item-4">
                            <SectionF4 />
                            <div className="desc">{t('sectionF.desc4')}</div>
                        </div>
                        <div className="item item-5">
                            <EFPic name={['05-5.webp', '05-5.png']} />
                            <div className="desc">{t('sectionF.desc6')}</div>
                        </div>
                    </div>
                </ScrollOpacity>
                <EFVideoModal
                    visible={videoModal}
                    source="https://www.youtube.com/embed/lpIFKQ5HlH8"
                    onClose={() => setVideoModal(false)}
                    playerType={playerType as any}
                />
            </div>
        </>
    );
}
